import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import api from '@/api';
import { ArticleDetailScreen } from '@/common/ArticleDetailScreen';
import { NotFoundScreen } from '@/common/ErrorScreen';

/**
 * A study helper tutorial single, behind `study-helper-tutorials.tsx`'s gate.
 */
function StudyHelperTutorialPost(): ReactElement | null {
  const { t } = useTranslation();
  const { slug } = Route.useParams();
  const { data, isError, isPending } = api.getStudyHelperTutorial.useQuery({
    path: { slug },
  });

  if (isError) return <NotFoundScreen />;
  if (isPending || data === undefined) return null;

  return (
    <ArticleDetailScreen
      article={{
        title: data.title,
        content: data.content,
        date: data.published_on,
        authorName: data.author_name,
        authorAvatarUrl: data.author_avatar_url,
      }}
      backPath="/study-helper-tutorials/"
      notFoundMessage={t('wbs.page-not-found')}
      // `showDate` stays at its default: legacy's single shows the date.
    />
  );
}

export const Route = createFileRoute('/_app/study-helper-tutorials/$slug')({
  component: StudyHelperTutorialPost,
});
